
















































import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { PanelUserService } from '@/modules/user/services/panel-user.service'
import UserProfileMailButton from '@/modules/user/components/shared/profile/UserProfileMailButton.vue'

@Component({
  components: { UserProfileMailButton, BaseButton, Modal, BaseInput, BaseCard }
})
export default class UserProfileNameForm extends Vue {
  constructor(
    private readonly service: PanelUserService
  ) {
    super()
  }

  @Prop() mail!: string
  @Prop() isVerified!: boolean
  loading = false


}
